<template>
    <div class="cloud-main">
        <div class="filter-bounce-patcher"></div>
        <div
            class="cloud-filter"
            :class="{
                'haveBanner': haveBanner,
                'alarm-type-selector-open': alarmTypeSelectorOpen,
                'has-mobile-selection-row': showVideoHandle && !isSearch
            }"
        >
            <div
                v-if="showVideoHandle && !isSearch"
                class="mobile-selection-row"
            >
                <button
                    v-if="openSelecte"
                    class="mobile-selectable-close"
                    type="button"
                    :aria-label="$t('cancel').toString()"
                    @click="openSelecteHandle( false )"
                >
                    <img :src="InputCloseIcon" alt="" />
                </button>
                <button
                    v-else
                    class="mobile-selectable-open"
                    type="button"
                    @click="openSelecteHandle( true )"
                >
                    {{ $tc('cloud.select') }}
                </button>
                <div class="mobile-selection-actions">
                    <reo-old-checkbox
                        v-if="showWillExpiredGallerySwitch"
                        :value="showExpired"
                        :text="$tc('cloud.showExpired')"
                        class="mobile-show-expired"
                        @input="showExpiredHanle"
                    />
                    <reo-old-checkbox
                        v-if="openSelecte"
                        :value="selectedAll"
                        :label="$tc('selectAll')"
                        class="mobile-select-all"
                        type="fill"
                        color="primary"
                        @input="selectedAllHandle"
                    />
                </div>
            </div>
            <div class="cloud-filter-inner">
                <div class='device-select-box'>
                    <reo-select v-if='deviceListOpt.length > 0'
                        ref="deviceSelect"
                        selectorType='multiple'
                        :widthOut='selectorStyle.widthOut'
                        :heightOut='selectorStyle.heightOut'
                        :widthIn='selectorStyle.widthIn'
                        :heightIn='selectorStyle.heightIn'
                        :selectMarginLeft='selectorStyle.selectMarginLeft'
                        :triangleRight='selectorStyle.triangleRight'
                        :maxHeight='selectorStyle.maxHeight'
                        :fontSizeIn='selectorStyle.fontSizeIn'
                        :fontSizeOut='selectorStyle.fontSizeOut'
                        :options="deviceListOpt"
                        :defaultSelected="defaultSelectedDevice"
                        colorType="light"
                        :value="device"
                        :maxSelect="10"
                        @selectionChange="val=>device = val"
                        :data-transaction-name="transactionNames.LEVEL1_LIBRARY_FILTER"
                    >
                    </reo-select>
                </div>
                <div class='alarmType-select-box' v-if='alarmTypeOptions.length !== 0'>
                    <alarm-type-selector
                        v-model="selectedAlarmTypeKeys"
                        :options="alarmTypeOptions"
                        :data-transaction-name="transactionNames.LEVEL1_LIBRARY_FILTER"
                        @change="handleAlarmTypeChange"
                        @open-change="alarmTypeSelectorOpen = $event"
                    />
                </div>
                <div ref="dateTimeRangePickerContainer"
                    class='dateTimeRangePickerContainer'
                    :class="{ 'mobile-date-only': isMobile }">
                    <reo-date-picker @change="onDateChange"
                        :timeStart="showExpired ? expiredTimeStart : timeStart"
                        :timeEnd="showExpired ? expiredTimeEnd : timeEnd"
                        :max='timeEnd'
                        :min='minTime'
                        :isHiddenClear=true
                        :ranges='ranges'
                        startTitle='Start'
                        endTitle='End'
                        mode='time'
                        :availableDays='isMobile ? null : availableDays'
                        :isMobile='isMobile'
                        :key='datePickerKey'
                        :class='{ "disabled": showExpired }'></reo-date-picker>
                </div>
            </div>
            <ai-search
                @search="handleSearch"
            />
        </div>
        <library-handle
            v-if="showVideoHandle && !isSearch"
            :selectable="openSelecte"
            :selectedAll="selectedAll"
            :galleryList="eventList"
            :showExpired="showExpired"
            :showWillExpiredGallerySwitch="showWillExpiredGallerySwitch"
            @openSelectableChange="openSelecteHandle"
            @selectedAllChange="selectedAllHandle"
            @showExpiredChange="showExpiredHanle"
            @delete="resetEvents"
        />
        <AiFeedbackBtns
            v-if="isSearch"
            :user-input="searchArgs"
        />
        <div class="video-list">
            <section
                v-for="group in groupedEventList"
                :key="group.date"
                class="video-date-group"
            >
                <h2 class="video-date-title">{{ group.date }}</h2>
                <div class="video-date-items">
                    <event-list-item
                        v-for="item in group.items"
                        :key="item.event.id"
                        :index="item.index"
                        :event="item.event"
                        :device="device"
                        :date="date"
                        @delete="resetEvents"
                        @selectHandle="selectHandle"
                        :showCheckbox="openSelecte"
                        :deviceObj="deviceObj"
                        :alarmTypes="alarmTypesList"
                        :navigation-context-id="navigationContextId"
                    />
                </div>
            </section>
        </div>
        <infiniteLoading
            @infinite="getEvents"
            :key="infiniteIdentifier"
            spinner="spiral"
            class="infinite-loading"
        >
            <div slot="spinner">
                <div class="processing-container">
                    <processing/>
                </div>
            </div>
            <div slot="no-more"><no-more/></div>
            <div slot="no-results"><no-video/></div>
            <div slot="error"><no-video/></div>
        </infiniteLoading>
        <div class="mobile-video-holder" v-show="showPagination && openSelecte"></div>
        <reo-dialog v-if="error"
            class="error"
            :labelOfConfirm="$tc('cloud.error.refresh')"
            :labelOfCancel="$tc('cloud.error.cancel')"
            :title="$tc('cloud.error.title')"
            :description="$tc('cloud.error.des') + errorReason"
            @confirm="refresh"
            @cancel="cancel"></reo-dialog>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import nprogress from 'nprogress';
import { config } from 'CONFIG';
import '@reolink-web/vue-datepicker/dist/style.css';
import ReoDialog from '@/basic/Dialog.vue';
import ReoSelect from '@/basic/ReoSelect.vue';
import ReoOldCheckbox from '@/basic/Checkbox.vue';
import EventListItem from './components/EventListItem.vue';
import NoVideo from './NoVideo.vue';
import ReoDatePicker from '@reolink-web/vue-datepicker/dist/index.umd';
import router from '@/router';
import { ISelectorStyle } from '@/interface';
import { timeResolve } from '@/common/js/date';
import { encodeBase64 } from '@/common/js/utils';
import { getDeviceInfoHasVideo, getVideoQuantityByPeriod } from '@/api/cloud';
import { getGalleryAlarmTypeList } from '@/api/gallery';
import { getEventList } from '@/api/event';
import { useStore } from '@/utils/store';
import blackCover from 'IMAGE/cloud/black-cover.png';
import { getDayZero, getTimeStamp, IEventWithExtraInfo } from './lib';
import {
    buildAlarmTypeTree,
    getAlarmTypeQueryKeys,
    getGalleryAlarmTypeRequestUids,
    getSupportedAlarmTypeKeys,
    IAlarmTypeTreeOption,
    reconcileAlarmTypeSelection
} from './lib/alarmTypeSelector';
import LibraryHandle from './components/LibraryHandle.vue';
import AlarmTypeSelector from './components/AlarmTypeSelector/index.vue';
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading';
import NoMore from '@/view/library/NoMore.vue';
import processing from '@/basic/processing.vue';
import AiSearch from './components/AiSearch.vue';
import {
    IAlarmType,
    IGetEventListRes,
    ISearchArgs,
    ISearchVideoEventsResponse
} from '@reolink-cloud/interface';
import { searchEvent } from '@/api/ai';
import AiFeedbackBtns from './components/AiFeedbackBtns.vue';
import { getDeviceTitle } from '@/utils/business';
import InputCloseIcon from '@/common/images/common/combo/co_inputclose_full.svg';
import {
    appendLibraryNavigationPage,
    createLibraryNavigationContext,
    createLibraryNavigationId,
    readLibraryNavigationContext,
    removeLibraryNavigationContext,
    saveLibraryNavigationContext
} from '../videos/libraryEventNavigation';

const DEFAULT_SHOW_VIDEOS_DAY = 30;
let nextToken = null as string | null;
const getTime = ( time: number | Date ): number => typeof time === 'number' ? time : time.getTime();

export default Vue.extend({

    components: {
        LibraryHandle,
        AlarmTypeSelector,
        EventListItem,
        ReoDatePicker,
        ReoSelect,
        ReoOldCheckbox,
        NoVideo,
        ReoDialog,
        InfiniteLoading,
        NoMore,
        processing,
        AiSearch,
        AiFeedbackBtns
    },

    async mounted () {

        this.updateMobileDateDisplay();
        const initializeAlarmTypeOptionsPromise = this.getSubDeviceList()
            .then(() => this.initializeAlarmTypeOptions());

        try {

            this.getHaveVideoDays();
            let videosPerDay = await getVideoQuantityByPeriod({
                start_at: this.sixtyDaysBefore,
                end_at: this.timeEnd
            });
            for ( let item of videosPerDay ) {

                if ( item.total === 1 ) {

                    this.availableDays.push(
                        getDayZero( getTimeStamp( this.timeEnd, 60 - item.index, 'before' ))
                    );

                }

            }

        } catch ( err ) {

            console.error( err );
            this.error = true;

        } finally {

            await initializeAlarmTypeOptionsPromise;
            nprogress.done();

        }

        try {

            this.showExpiredLabel = this.eventList.length > 0;

        } catch ( err ) {

            console.error( err );
            let code = ( err as AxiosError ).code ?? '-1';
            if ( code && parseInt( code ) === 53258 ) {

                await router.push( '/user/subscribe-plan/cloud/' );

            }

        }
        this.showContent = true;

    },

    destroyed () {

        nextToken = null;

    },

    provide () {

        return {
            getCmkInfo: ( videoId ) => this.cmkInfoStore.get( videoId )
        };

    },

    data () {

        const defaultSelectedDevice = [this.$route.query.device ?? 'all' ] as string[];

        return {

            data: true,
            InputCloseIcon,
            device: defaultSelectedDevice,
            defaultSelectedDevice,
            page: 1,
            date: this.$route.query.date as string,
            count: 0,
            openSelecte: false,
            deviceList: [] as any[],
            deviceListOpt: [] as any[],
            deviceObj: {} as Record<string, any>,
            eventList: [] as any[],
            hasMore: false,
            showContent: false,
            cloudVideoPageUnit: config.cloudVideoPageUnit,
            error: false,
            errorReason: '',
            showExpired: false,
            showExpiredLabel: false,
            paddingFixedDis: 0,
            paddingStaticDis: 0,
            alarmTypesList: [] as IAlarmType[],
            alarmTypeOptions: [] as IAlarmTypeTreeOption[],
            selectedAlarmTypeKeys: [] as string[],
            alarmTypeSelectorOpen: false,
            alarmTypeRequestId: 0,
            alarmTypeFilterLoading: false,
            eventRequestId: 0,
            dialogStack: [] as any[],
            videoRetentionDays: 0,
            timeStart: 0,
            timeEnd: 0,
            expiredTimeStart: 0,
            expiredTimeEnd: 0,
            timeRange: {} as Record<string, any>,
            time: new Date(),
            minTime: 0,
            ranges: ['today', 'yesterday', 'week', 'month'],
            availableDays: [] as any[],
            showAlert: true,
            pinVerified: undefined,
            enabledCmk: undefined,
            passphrase: '',
            cmkInfoStore: useStore({ cover: false }),
            infiniteIdentifier: 0,
            searchText: '',
            navigationContextId: createLibraryNavigationId()
        };

    },

    methods: {

        updateMobileDateDisplay (): void {

            if ( !this.isMobile ) {

                return;

            }

            this.$nextTick(() => {

                const container = this.$refs.dateTimeRangePickerContainer as HTMLElement | undefined;
                const datePickers = container?.querySelectorAll<HTMLElement>( '.datepicker' );
                const displayTimes = [
                    this.showExpired ? this.expiredTimeStart : this.timeStart,
                    this.showExpired ? this.expiredTimeEnd : this.timeEnd
                ];
                const datePickerCount = Math.min( datePickers?.length ?? 0, displayTimes.length );
                for ( let index = 0; index < datePickerCount; index++ ) {

                    const datePicker = datePickers![index];
                    const date = dayjs( displayTimes[index] );
                    if ( !date.isValid()) {

                        continue;

                    }
                    datePicker.dataset.displayDate = date.format( 'MM/DD' );

                }

            });

        },

        async getEvents ( $state: StateChanger ): Promise<void> {

            if ( this.alarmTypeFilterLoading ) {

                $state.complete();
                return;

            }

            const requestId = this.eventRequestId;

            try {

                const commonSearchArgs = {
                    startAt: new Date( this.timeStart ).getTime(),
                    endAt: new Date( this.timeEnd ).getTime(),
                    limit: this.cloudVideoPageUnit,
                    alarmTypes: this.alarmTypeQueryKeys,
                    uids: this.deviceArgs
                };
                const videosData = await ( !this.isSearch
                    ? getEventList( nextToken
                        ? { nextToken }
                        : {
                            ...commonSearchArgs,
                            timeType: 'recordedAt',
                            sequence: true
                        })
                    : searchEvent( nextToken
                        ? { nextToken }
                        : {
                            ...commonSearchArgs,
                            query: this.searchText,
                            timeType: 'relevance'
                        })
                );

                if ( requestId !== this.eventRequestId ) return;

                const events = videosData.items;
                const total = videosData.totalRows;
                nextToken = videosData.nextToken;
                this.syncLibraryNavigationContext( videosData );

                if (  events.length > 0 ) {

                    for ( let event of ( events as IEventWithExtraInfo[] )) {

                        const item = event.items[0];
                        const coverUrl = item.files.find( file => file.type === 'image' )?.url ?? '';
                        event.coverUrl = coverUrl ?? blackCover;
                        event.checked = false;

                    }

                    this.count = total;
                    this.eventList = this.eventList.concat( events );
                    this.hasMore = events.length === config.cloudVideoPageUnit;
                    $state.loaded();

                }
                if ( !nextToken ) {

                    $state.complete();

                }

            } catch ( err ) {

                if ( requestId !== this.eventRequestId ) return;

                console.log( err );
                this.error = true;
                this.errorReason = `[getVideoError-${encodeBase64(( err as AxiosError ).response?.data.error.symbol  )}]`;
                console.error( err );
                $state.error();

            }

        },

        async getSubDeviceList (): Promise<void> {

            try {

                let devices: any = await getDeviceInfoHasVideo();
                let deviceList: any[] = [];
                let deviceObj = {};
                let SupportedAlarmTypes: string[] = [];
                for ( let device of devices ) {

                    if ( device.uid ) {

                        let label = getDeviceTitle( device, true );
                        let extraLabel = '';
                        if ( device.boundStatus === 'unbound' ) {

                            extraLabel = `(${this.$tc( 'unbound' )})`;

                        }
                        else if ( device.status === 'unassociated' ) {

                            extraLabel = `(${this.$tc( 'unAssociate' )})`;

                        }
                        label += extraLabel;
                        let features = typeof device.features.features !== 'undefined' ? device.features.features : [];
                        let alarmTypes: any[] = [];
                        for ( let item of features ) {

                            alarmTypes = alarmTypes.concat( item.alarmTypes );

                        }
                        alarmTypes = Array.from( new Set( alarmTypes ));
                        deviceList.push({

                            label: label,
                            status: device.status === 'associated' ? '' : device.boundStatus === 'unbound' ? '(unbound)' : '(unassociated)',
                            value: device.uid,
                            key: device.uid,
                            videoRetentionDays: device.videoRetentionDays,
                            alarmTypes: alarmTypes,
                            id: device.uid

                        });
                        SupportedAlarmTypes = Array.from( new Set( SupportedAlarmTypes.concat( alarmTypes )));
                        deviceObj[device.uid] = getDeviceTitle( device, true );

                    }

                }
                this.deviceList = [];
                this.deviceList = deviceList;
                this.deviceObj = deviceObj;

                this.deviceListOpt = [...deviceList.sort(( a, b ) =>

                    a.label.localeCompare( b.label )

                )];
                this.deviceListOpt.unshift({
                    label: this.$t( 'cloud.allDevices' ),
                    value: 'all',
                    key: 'all',
                    id: 'all',
                    alarmTypes: SupportedAlarmTypes
                });

            } catch ( err ) {

                this.errorReason = `[getDevicesError-${encodeBase64(( err as AxiosError ).response?.data.error.symbol  )}]`;
                this.error = true;
                console.error( err );

            }

        },

        openSelecteHandle ( openSelecte ): void {

            if ( !openSelecte ) {

                this.selectedAllHandle( false );

            }
            this.openSelecte = openSelecte;

        },

        selectedAllHandle ( selectedAll ): void {

            if ( selectedAll ) {

                this.openSelecte = selectedAll;

            }
            let videoList: Array<{ checked: boolean; }> = this.eventList;
            for ( let video of videoList ) {

                Reflect.set( video, 'checked', selectedAll );

            }

        },

        selectHandle ({ index, checked }): void {

            this.$set( this.eventList[ index ], 'checked', checked );

        },

        refresh (): void {

            window.location.reload();

        },

        cancel (): void {

            this.error = false;

        },

        async showExpiredHanle ( showExpired: boolean ): Promise<void> {

            this.showExpired = showExpired;
            for ( let device of this.deviceList ) {

                if ( this.device === device.value ) {

                    this.videoRetentionDays = device.videoRetentionDays;

                }

            }
            if ( this.deviceList.length === 1 && this.device.includes( 'all' )) {

                this.videoRetentionDays = this.deviceList[0].videoRetentionDays;

            }

            this.expiredTimeStart = getDayZero( getTimeStamp( new Date().getTime(), this.videoRetentionDays, 'before' ));
            this.expiredTimeEnd = getTimeStamp( new Date().getTime() - this.videoRetentionDays * 86400000, 3, 'after' );
            if ( showExpired ) {

                this.timeStart = this.expiredTimeStart;
                this.timeEnd = this.expiredTimeEnd;

            } else {

                this.timeEnd = new Date().getTime();

            }

            await this.refreshAlarmTypesAndEvents( false );

        },

        handleAlarmTypeChange ( val: string[] ): void {

            this.selectedAlarmTypeKeys = val;
            this.resetEvents();

        },

        getHaveVideoDays (): void {

            this.timeEnd = new Date().getTime();
            this.minTime = this.sixtyDaysBefore;
            this.timeStart = getDayZero( getTimeStamp( this.timeEnd, DEFAULT_SHOW_VIDEOS_DAY, 'before' ));

        },

        resetEvents(): void {

            this.eventRequestId++;
            this.eventList = [];
            this.infiniteIdentifier++;
            nextToken = null;
            removeLibraryNavigationContext( this.navigationContextId );
            this.navigationContextId = createLibraryNavigationId();
            window.scrollTo( 0, 0 );

        },
        syncLibraryNavigationContext (
            videosData: IGetEventListRes | ISearchVideoEventsResponse
        ): void {

            const source = this.isSearch ? 'ai' : 'filter';
            const existingContext = readLibraryNavigationContext( this.navigationContextId );
            const context = existingContext?.source === source
                ? appendLibraryNavigationPage( existingContext, videosData )
                : createLibraryNavigationContext( source, videosData );
            saveLibraryNavigationContext( this.navigationContextId, context );

        },
        async onDateChange( time: { start: number|Date;end: number|Date; }): Promise<void> {

            this.timeStart =  getTime( time.start );
            this.timeEnd = getTime( time.end );

            await this.refreshAlarmTypesAndEvents( false );

        },
        handleSearch ( searchText: string ): void {

            this.searchText = searchText;
            this.resetEvents();

        },
        async initializeAlarmTypeOptions(): Promise<void> {

            try {

                await this.refreshAlarmTypeOptions( true );

            } catch ( err ) {

                this.handleAlarmTypeLoadError( err as AxiosError );

            }

        },
        async refreshAlarmTypesAndEvents( resetSelection: boolean ): Promise<void> {

            this.alarmTypeFilterLoading = true;
            this.resetEvents();

            try {

                const applied = await this.refreshAlarmTypeOptions( resetSelection );
                if ( !applied ) return;

                this.alarmTypeFilterLoading = false;
                this.resetEvents();

            } catch ( err ) {

                this.alarmTypeFilterLoading = false;
                this.handleAlarmTypeLoadError( err as AxiosError );

            }

        },
        async refreshAlarmTypeOptions( resetSelection: boolean ): Promise<boolean> {

            const requestId = ++this.alarmTypeRequestId;

            try {

                const selectedUids = this.deviceArgs;
                const response = await getGalleryAlarmTypeList({
                    start_at: this.timeStart,
                    end_at: this.timeEnd,
                    uid: getGalleryAlarmTypeRequestUids( selectedUids ),
                    language: this.lang
                });

                if ( requestId !== this.alarmTypeRequestId ) return false;

                const supportedKeys = getSupportedAlarmTypeKeys( this.deviceList, selectedUids );
                const options = buildAlarmTypeTree( response, supportedKeys );
                this.alarmTypesList = response.alarmTypes;
                this.alarmTypeOptions = options;
                this.selectedAlarmTypeKeys = resetSelection
                    ? []
                    : reconcileAlarmTypeSelection( this.selectedAlarmTypeKeys, options );

                return true;

            } catch ( err ) {

                if ( requestId === this.alarmTypeRequestId ) throw err;
                return false;

            }

        },
        handleAlarmTypeLoadError( err: AxiosError ): void {

            console.error( err );
            const symbol = err.response?.data?.error?.symbol;
            this.errorReason = `[getAlarmTypesError-${encodeBase64(
                typeof symbol === 'string' ? symbol : 'unknown'
            )}]`;
            this.error = true;

        },

    },

    computed: {

        selectedAll (): boolean {

            let videoList = this.eventList;
            let selectedAll = true;
            if ( videoList.length === 0 ) {

                selectedAll = false;

            } else {

                for ( let video of videoList ) {

                    if ( !video.checked ) {

                        selectedAll = false;
                        break;

                    }

                }

            }
            return selectedAll;

        },

        groupedEventList(): Array<{
            date: string;
            items: Array<{ event: IEventWithExtraInfo; index: number; }>;
        }> {

            const groups = new Map<string, Array<{ event: IEventWithExtraInfo; index: number; }>>();

            for ( const [index, event] of this.eventList.entries()) {

                const { year, month, dateOfMonth } = timeResolve( event.recordedAt );
                const date = `${year}-${month}-${dateOfMonth}`;
                const items = groups.get( date ) ?? [];
                items.push({ event, index });
                groups.set( date, items );

            }

            return Array.from( groups, ( [date, items] ) => ({ date, items }));

        },

        showVideoHandle(): boolean {

            return this.eventList.length > 0 || this.showWillExpiredGallerySwitch;

        },

        showWillExpiredGallerySwitch(): boolean {

            return this.deviceArgs?.length === 1;

        },
        alarmTypeQueryKeys(): string[] | undefined {

            if ( this.selectedAlarmTypeKeys.length === 0 ) return undefined;
            return getAlarmTypeQueryKeys( this.selectedAlarmTypeKeys, this.alarmTypeOptions );

        },
        selectorStyle (): ISelectorStyle {

            return !this.isMobile ? {
                widthOut: 2.0,
                heightOut: 0.4,
                widthIn: 2.0,
                heightIn: 0.4,
                selectMarginLeft: 0.12,
                triangleRight: 0.12,
                maxHeight: 3.08,
                fontSizeIn: 0.14,
                fontSizeOut: 0.14
            } : {
                widthOut: -1,
                heightOut: 0.36,
                widthIn: -1,
                heightIn: 0.46,
                selectMarginLeft: 0.12,
                triangleRight: 0.12,
                maxHeight: 4.75,
                fontSizeIn: 0.17,
                fontSizeOut: 0.14
            };

        },

        sixtyDaysBefore (): number  {

            return getDayZero( getTimeStamp( this.timeEnd, 60, 'before' ));

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        lang(): string {

            return this.$store.getters.lang;

        },

        haveBanner (): boolean {

            return this.$store.state.user.user.status === 'pending';

        },

        userId(): boolean {

            return this.$store.getters.userId;

        },

        showPagination (): boolean {

            return this.eventList.length !== 0 && this.showContent;

        },

        datePickerKey(): number {

            return Number( this.isMobile ) + Number( this.showExpired );

        },

        mobileDateDisplayKey(): string {

            if ( !this.isMobile ) {

                return '';

            }

            const start = this.showExpired ? this.expiredTimeStart : this.timeStart;
            const end = this.showExpired ? this.expiredTimeEnd : this.timeEnd;
            return `${this.datePickerKey}:${start}:${end}`;

        },

        searchArgs(): ISearchArgs {

            const uids = this.device.includes( 'all' ) ? undefined : this.device;
            const commonSearchArgs = {
                startAt: new Date( this.timeStart ).getTime(),
                endAt: new Date( this.timeEnd ).getTime(),
                timeType: 'uploadedAt',
                limit: this.cloudVideoPageUnit,
                alarmTypes: this.alarmTypeQueryKeys,
                uids,
            };

            return {
                ...commonSearchArgs,
                query: this.searchText,
                timeType: 'relevance',
                limit: this.cloudVideoPageUnit
            };

        },
        isSearch(): boolean {

            return this.searchText !== '';

        },
        deviceArgs(): string[]|undefined {

            if ( this.deviceListOpt.length === 1 && this.deviceListOpt[0].value !== 'all' ) {

                return [this.deviceListOpt[0].value];

            }

            return this.device.includes( 'all' ) ? undefined : this.device;

        }

    },

    watch: {

        mobileDateDisplayKey () {

            this.updateMobileDateDisplay();

        },

        async device ( ) {

            try {

                this.selectedAlarmTypeKeys = [];
                this.showExpired = false;
                if ( this.deviceArgs?.length === 1 ) {

                    this.videoRetentionDays = this.deviceList.find( item => item.id === this.deviceArgs![0] )?.videoRetentionDays ?? 0;

                }
                await this.refreshAlarmTypesAndEvents( true );

            } catch ( err ) {

                this.handleAlarmTypeLoadError( err as AxiosError );

            }

        },

        date ( ) {

            if ( this.showExpired ) {

                this.showExpired = false;

            }
            this.resetEvents();

        },

        isSearch( newVal: boolean ) {

            if ( newVal ) {

                this.openSelecte = false;

            }

        }

    }

});
</script>

<style lang="less" scoped>
    .cloud-wrap{
        min-height: 6.5rem;
        @media @mobile{
            min-height: 9rem;
        }
    }
    .cloud-main{
        max-width: 1200px;
        margin: 0 auto;
        background-color: @bg_01;
    }
    .cloud-fillter{
        background: @bg_01;
    }
    .video-list{
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin-bottom: 0;
        @media @mobile{
            padding-top:.48rem;
        }
    }
    .video-date-group{
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
    .video-date-title{
        color: @font_primary;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
    }
    .video-date-items{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
    }
    .cloud-filter-inner{
        align-items: center;
        box-sizing: border-box;
        display: flex;
        margin: 24px 0;
        gap: 10px;
    }
    .device-select-box{
        /deep/ .selectInfos{
            text-align: left;
        }
        height: 40px;
    }
    .dateTimeRangePickerContainer{
        /deep/ .dateTimeRangePicker,
        /deep/ .dateTimeRangePicker .datepicker,
        /deep/ .dateTimeRangePicker .datepicker > input{
            background: transparent;
        }
    }
    .video-list-current-day{
        display: none;
    }
    @media screen and (max-width:1199px) {
        .device-select-box {
            flex: 1 1 0;
            max-width: 200px;
            min-width: 0;

            /deep/ .divSelectInput {
                min-width: 0;
            }

            /deep/ .selectInfos {
                min-width: 0;
                flex: 1 1 auto;
            }
        }

        .alarmType-select-box {
            flex: 1 1 0;
            width: auto;
            min-width: 0;
            max-width: 200px;
        }

        .dateTimeRangePickerContainer.mobile-date-only {
            /deep/ .dateTimeRangePicker {
                padding: 0 8px;

                .arrow,
                .clock {
                    font-size: 16px;
                }

                .datepicker {
                    flex: 0 0 clamp(40px, 10vw, 120px);
                    position: relative;
                    width: clamp(40px, 10vw, 120px);

                    &::after {
                        color: #333;
                        content: attr(data-display-date);
                        font-size: 12px;
                        font-weight: 500;
                        left: 0;
                        pointer-events: none;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }

                    > input {
                        color: transparent !important;
                        width: 100%;
                    }
                }
            }

            /deep/ .disabled .datepicker::after {
                color: #ccc;
            }
        }
        .video-list-current-day.has-video{
            font-size: 0.3rem;
            display: block;
            width: 100%;
            line-height: 0.88rem;
            background-color: #fff;
            font-weight: 500;
            padding-left: 15px;
            z-index: 3;
            box-sizing: border-box;
        }
        .has-shadow.video-list-current-day.has-video{
            box-shadow: 0 0.06rem 0.3rem rgba(255, 255, 255, 0.1);
        }
        .video-list-current-day.has-video.hasShadow{
            box-shadow: 0 0.06rem 0.3rem rgba(255,255,255,.1);
        }
        .cloud-filter-inner{
            width: 100%;
            overflow-x: scroll;
            padding: 0 16px;
            justify-content: flex-start;
            gap: 12px;
            height: unset;
            margin: 0;
            &::-webkit-scrollbar{
                display: none;
            }
            scrollbar-width: none;
        }
        .device-select-box{
            height: 36px;
        }
    }
    .cloud-filter-inner>div{
        display: inline-block;
        text-align: center;
        box-sizing: border-box;

    }
    .cloud-datepicker{
        display: inline-block;
    }
    @media screen and (max-width:1199px) {
        .video-list{
            gap: 16px;
            padding: 0 20px;
            margin-top: 0;
            padding-top: .3rem;
        }
        .video-date-group,
        .video-date-items{
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    }
    .reo-dialog.error.dialog{
        & /deep/ .reo-dialog-inner{
            @media @pc{
                min-height:unset;
            }
        }
    }
    .pin-container {
        font-family: Quicksand-Medium-, Quicksand-Medium;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .pin-frame {
        font-family: Quicksand-Medium-, Quicksand-Medium;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex-direction: column;
        max-width: 8rem;

        @media @mobile {
            margin: 0 0.3rem;
        }
    }
    .pin-title {
        // font-weight: normal;
        text-align: center;
        font-size: 24px;
    }
    .pin-helper {
        // font-weight: normal;
        font-size: 16px;
        color: #555555;
        line-height: 28px;
        margin-top: 20px;
        text-decoration: underline;
    }
    .pin-input {
        margin-top: 40px;
        width: 410px;

        @media screen and (max-width: 500px) {
            width: 100%;
        }

        /deep/ .el-input--reo .el-input__inner {
            height: 48px;
            line-height: 48px;
        }
    }

    .pin-confirm-button {
        .ui-button {
            font-size: 16px;
            line-height: 20px;
            border-radius: 24px;
            padding: 14px 24px;
        }
        margin: 20px 0;
    }

    .pin-forget-link {
        color:#00ade5;
    }

    .pin-hr {
        margin: 40px 0;
        background-color: #A5A5A5;
        width: 100%;
        height: 1px;
    }

    .pin-note {
        font-family: Quicksand-Regular, Quicksand;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #555555;
        text-align: center;
    }

</style>
<style lang="less">
@media screen and (max-width:1199px) {
    .app-platform .mobile-video-holder {
        height: 68px;
    }
}
</style>
<style lang="less" scoped>
    .filter-bounce-patcher{
        height: 120px;
        @media @snapeak_mobile {
            height: 118px;
        }
    }

    .app-platform .cloud-filter {
        &, &.haveBanner {
            top: 0;
        }
    }

    .cloud-filter{
        @media @pc{
            padding-top: 24px;
        }
        position: fixed;
        top: 80px;
        width: 1200px;
        z-index: 5;
        background: @bg_01;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media @mobile{
            top: 50px;
            width: 100%;
            display: flex;
            flex-direction: column-reverse;
            gap: 16px;
            padding: 16px 0;
            align-items: flex-start;

            &.has-mobile-selection-row{
                padding-bottom: 20px;
            }

            &.alarm-type-selector-open{
                // The nested dialog must stay above mobile-gallery-handle (z-index: 10).
                z-index: 999;
            }
        }

    }

    .mobile-selection-row{
        display: none;
    }

    @media @mobile{
        .mobile-selection-row{
            align-items: center;
            background: @bg_01;
            box-sizing: border-box;
            display: flex;
            flex: 0 0 24px;
            height: 24px;
            justify-content: space-between;
            padding: 0 20px;
            width: 100%;
        }
        .mobile-selectable-close,
        .mobile-selectable-open{
            background: transparent;
            border: 0;
            cursor: pointer;
            padding: 0;
        }
        .mobile-selectable-close{
            height: 24px;
            width: 24px;
        }
        .mobile-selectable-close img{
            display: block;
            height: 24px;
            width: 24px;
        }
        .mobile-selectable-open{
            color: @brand_light;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            text-align: left;
        }
        .mobile-selection-actions{
            align-items: center;
            display: flex;
            gap: 24px;
            padding: 0 12px;
        }
        .mobile-show-expired{
            /deep/ .reo-checkbox{
                border-width: 1px;
            }
            align-items: center;
            display: flex;
            flex-direction: row-reverse;
            gap: 6px;
        }
        .mobile-select-all{
            /deep/ .reo-checkbox{
                border-width: 2px;
            }
            /deep/ .checkbox-wrap{
                align-items: center;
                display: flex;
                flex-direction: row-reverse;
                gap: 6px;
            }
        }
        .mobile-show-expired,
        .mobile-select-all{
            /deep/ .checkbox-label,
            /deep/ .text{
                color: @font_primary;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                white-space: nowrap;
            }
            /deep/ .reo-checkbox{
                height: 20px;
                width: 20px;
            }
        }
    }

    .infinite-loading {
        width: 100%;
        /deep/ .no-more{
            margin-top: 0;
            padding: 24px 0;
        }
    }
</style>
